var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adviser-benefit-card-grid"},_vm._l((_vm.cards),function(card,index){return _c('AdviserBenefitCard',_vm._b({key:`${card.title}-${index}`},'AdviserBenefitCard',card,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }